import React from 'react';
import '../Footer/Footer.css';
import owner from "../../img/logo1.png";
import { NavLink } from 'react-router-dom';

function Footer() {
  return (
  
<footer className="footer bg-dark text-light pt-5 pb-3">
  <div className="container">
    <div className="row">
     
      <div className="col-lg-4 col-md-6 mb-4">
        <img src={owner} alt="Just BLR Logo" className="mb-3" style={{maxWidth: '180px', height:'120px'}} />
        <p>
         Raju Caterer has established itself as one of the most sought-after catering companies in Bangalore and the surrounding areas, known for its exceptional service, delicious cuisine, and unwavering commitment to customer satisfaction.
        </p>
       
        {/* <div class="social-icons mt-3">
          <a href="#" class="me-3 text-light"><i class="bi bi-facebook"></i></a>
          <a href="#" class="me-3 text-light"><i class="bi bi-instagram"></i></a>
          <a href="#" class="text-light"><i class="bi bi-x"></i></a>
        </div> */}
      </div>

     
      <div className="col-lg-5 col-md-6 mb-4 border-md-start border-light">
        <h5 className="mb-3">VISIT US HERE</h5>
        <p className="mb-1">#12, 1st cross, St. James Church Road, Maria Street, Mariyannapalya,<br/> Kempapura, Hebbal, Bengaluru - 560024</p>
        <p className="mb-1">Call us : <a href="tel:+919880104505" class="text-light">+91 988 010 4505</a></p>
        <p>Email : <a href="mailto:info@rajucaterer.in" class="text-light">rajucaterer1@gmail.com</a></p>
      </div>

      
      <div className="col-lg-3 col-md-6 mb-4 border-md-start border-light">
        <h5 className="mb-3">QUICK LINKS</h5>
        <ul className="list-unstyled">
          <li><NavLink to="/" className="text-light text-decoration-none">Home</NavLink></li>
          <li><NavLink to="/about" className="text-light text-decoration-none">About Us</NavLink></li>
          <li><NavLink to="/services" className="text-light text-decoration-none">Services</NavLink></li>
          <li><NavLink to="/menu" className="text-light text-decoration-none">Menu</NavLink></li>
          <li><NavLink to="/gallery" className="text-light text-decoration-none">Gallery</NavLink></li>
          <li><NavLink to="/contact" className="text-light text-decoration-none">Contact Us</NavLink></li>
        </ul>
      </div>
    </div>

    
    <div className="text-center mt-4 pt-3 border-top border-light">
      <p className="mb-0">
        © 2025. <strong>Raju Caterer</strong>. All Rights Reserved.
      </p>
    </div>
  </div>
</footer>
  )
}

export default Footer
